import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-10 pb-4 px-6 flex flex-col items-center text-center relative overflow-hidden" data-id="element-83">
      {/* Ethereal background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-gradient-to-b from-[#D4B896]/20 to-transparent rounded-full blur-[100px] pointer-events-none" data-id="element-84" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-[#C9A66B]/10 rounded-full blur-[80px] pointer-events-none" data-id="element-85" />

      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="relative z-10" data-id="element-86">
        <img src="https://cdn.magicpatterns.com/uploads/1BDMi8dTaHKqZGDxUSRsDT/logo_gemmamama_transparent.png" alt="Gemma Mama Logo" className="h-14 md:h-20 w-auto object-contain mb-5" data-id="element-87" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: -5
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.15
    }} className="relative z-10 flex items-center justify-center gap-3 mb-5 w-full max-w-[90%]" data-id="element-88">
        <div className="h-[1px] w-6 bg-gradient-to-r from-transparent to-copper/40" data-id="element-89" />
        <span className="font-inter text-[9px] md:text-[10px] font-bold tracking-[0.15em] uppercase text-transparent bg-clip-text text-center leading-snug" style={{
        backgroundImage: 'linear-gradient(135deg, #7A4A20 0%, #A0652E 35%, #C9A66B 52%, #A0652E 68%, #7A4A20 100%)'
      }} data-id="element-90">
          10 Micro-Audio Guides for Postpartum Nervous System Regulation
        </span>
        <div className="h-[1px] w-6 bg-gradient-to-l from-transparent to-copper/40" data-id="element-91" />
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.25
    }} className="relative z-10 font-playfair text-[2.35rem] leading-[1.1] md:text-6xl font-medium mb-5 tracking-tight" data-id="element-92">
        <span className="text-charcoal opacity-90" data-id="element-93">Your hands are full.</span>
        <br data-id="element-94" />
        <span className="italic text-copper" data-id="element-95">Your ears are free.</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="relative z-10 font-inter text-charcoal text-[15px] md:text-lg opacity-70 max-w-sm leading-relaxed mb-6 font-light" data-id="element-96">
        The only postpartum support designed to meet you exactly where you are —{' '}
        <strong className="font-semibold opacity-100 text-copper" data-id="element-97">
          one earbud, two minutes, zero guilt.
        </strong>
      </motion.p>

      {/* Hero Mockup Image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      delay: 0.45,
      ease: 'easeOut'
    }} className="relative z-10 w-full max-w-[280px] mb-6" data-id="element-98">
        <motion.div animate={{
        y: [0, -6, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-99">
          <img src="https://cdn.magicpatterns.com/uploads/bpP4uNBt6nDhBuzAr9imCH/mockup3.png" alt="Mom using The Audio Sanctuary while holding her baby" className="w-full h-auto rounded-2xl shadow-[0_20px_50px_-15px_rgba(201,166,107,0.35)] border border-white/40" data-id="element-100" />
        </motion.div>
      </motion.div>

      <motion.button onClick={() => {
      document.getElementById('pricing-value')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1,
      delay: 0.55,
      ease: 'easeOut'
    }} className="relative z-10 w-full max-w-[280px] group mb-4" data-id="element-101">
        <div className="absolute -inset-1 bg-gradient-to-r from-copper via-gold to-copper rounded-full blur opacity-30 group-hover:opacity-60 transition duration-500 group-hover:duration-200 animate-pulse" data-id="element-102" />
        <div className="relative bg-gradient-to-r from-[#B87333] to-[#D4B896] text-white font-inter font-bold text-base py-4 rounded-full shadow-[0_8px_20px_rgba(184,115,51,0.3),inset_0_1px_1px_rgba(255,255,255,0.4)] border border-[#C9A66B]/50 transition-all" data-id="element-103">
          Yes — I Want My Sanctuary
        </div>
      </motion.button>

      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 0.8,
      delay: 0.7
    }} className="relative z-10 w-24 h-[1px] bg-gradient-to-r from-transparent via-copper to-transparent opacity-40 mt-4" data-id="element-104" />
    </section>;
}